export const IOVATION_SCRIPT_LOAD_SUCCESS = 'IOVATION_SCRIPT_LOAD_SUCCESS';
export const IOVATION_SCRIPT_LOAD_ERROR = 'IOVATION_SCRIPT_LOAD_ERROR';
